import { faPencilAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FieldEditProps } from "components/forms/part/FieldEdit/types";
import { Component } from "react";

export class FieldEdit extends Component<FieldEditProps> {
	render():JSX.Element{
		const icon = this.props.edit ? faPencilAlt : faTimesCircle;

		return (
			<div className={`field-edit`}>
				<FontAwesomeIcon icon={icon} onClick={this.props.action}/>
			</div>
		);
	}
}
